import { AutosaveManager } from "@coze-studio/autosave";

import { type ParameterStoreProps, useParameterStore } from "@rokid/store";
import { type ItemType } from "./type";
import { inputParameterConfig } from "./config";

export const createInputParameterSaveManager = (saveRequest) => {
  return new AutosaveManager<ParameterStoreProps, ItemType, any>({
    store: useParameterStore,
    registers: [inputParameterConfig],
    saveRequest,
  });
};
